import React from 'react'
import { editorType } from '../creator'
import { classes } from './SopViewer'
import { editorSections as cppSections } from "../creator/CCPEditor"
import { editorSections as hazardStepSections } from "../creator/HazardStepsEditor"

export default function({sops, doctype, id, ...params}){
    switch(doctype){
        case editorType.hi:
            return(
                <div key={id} id={id} >
                    <style>{`
                        table {
                            border-collapse: collapse;
                            width:100%;
                            max-width: 950px;
                        }

                        #hi thead > tr > th {
                            background: #999 ;
                        }

                    `}</style>
                    <table id="hi">
                        <thead>
                            <tr>
                                <th style={classes.tableText}> Input / Ingredient </th>
                                <th style={classes.tableText}> Potential Hazards <br/> (B) Biological <br/> (C) Chemical <br /> (P) Physical </th>
                                <th style={classes.tableText}> Measures to prevent, eliminate or reduce Hazards </th>
                            </tr>
                        </thead>
                        <tbody>
                            {sops.map( x => (
                                <>
                                    <tr>
                                        <td rowSpan={4}><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.title}}/></td>
                                    </tr>
                                    <tr>
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(B) ${x?.biological_hazard}` }} /></td>    
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.bh_measure }}/></td>    
                                    </tr> 
                                    <tr>
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(C) ${x?.chemical_hazard}` }}/></td>    
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.ch_measure }}/></td>    
                                    </tr> 
                                    <tr>
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(P) ${x?.physical_hazard}` }}/></td>    
                                        <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.ph_measure }}/></td>    
                                    </tr>
                                </>
                            ))}
                            
                        </tbody>
                    </table>
                </div>
            )
        case editorType.hs:
            
            return(
                <>
                    <style>{`
                        table {
                            border-collapse: collapse;
                            width:100%;
                            max-width: 950px;
                        }

                        #hs thead > tr > th {
                            background: #999 ;
                        }
                        
                        #hs tbody > tr > td {
                            overflow: hidden;
                            text-overflow: ellipsis;
                            text-align:justify;
                            white-space: break-spaces;
                        }
                        `}
                    </style>
                    <div id={id+"_desc"} >
                        <table id="hs">
                            <thead>
                                <tr>
                                    <th style={classes.tableText}>Process Step</th>
                                    <th style={classes.tableText}>Description</th>
                                </tr>
                            </thead>
                            <tbody>
                                { sops.map( x => (
                                        <tr>
                                            <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.title}}/></td>
                                            <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.description}}/></td>
                                        </tr>
                                )) }
                            </tbody>
                        </table>
                    </div>
                    <div key={id} id={id} >
                        <p style={classes.upperNote}>RLTO: Reasonably likely to occur. CCP: Critical Control Point</p>
                        <table id="hs" style={{tableLayout:'fixed'}}>
                            <thead>
                                <tr>
                                    <th style={classes.tableText}> Process Step </th>
                                    <th style={classes.tableText}> Potential Hazards <br/> (B) Biological <br/> (C) Chemical <br /> (P) Physical </th>
                                    <th style={classes.tableText}> Are These Hazards RLTO ? </th>
                                    <th style={classes.tableText}> Justification </th>
                                    <th style={classes.tableText}> {hazardStepSections.measures} </th>
                                    <th style={classes.tableText}> {hazardStepSections.ccp} </th>
                                </tr>
                            </thead>
                            <tbody>
                                { sops.map( x => {
                                    
                                    const is_bh = (typeof x.bh_rlto == 'boolean') ? (x.bh_rlto) ? 'Yes' : 'No' : 'No';
                                    const is_ch = (typeof x.ch_rlto == 'boolean') ? (x.ch_rlto) ? 'Yes' : 'No' : 'No';
                                    const is_ph = (typeof x.ph_rlto == 'boolean') ? (x.ph_rlto) ? 'Yes' : 'No' : 'No';
                                    const is_ccp = (typeof x.ccp == 'boolean') ? (x.ccp) ? 'Yes' : 'No' : 'No';
                                    
                                    return (
                                        <>
                                            <tr>
                                                <td rowSpan={4}><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.title}}/></td>
                                            </tr>
                                            <tr>
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(B) ${x?.biological_hazard}` }} /></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: is_bh}}/></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.bh_justification}}/></td>    
                                                <td rowSpan={4}><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.measures}}/></td>
                                                <td rowSpan={4}><div style={classes.tableText} dangerouslySetInnerHTML={{__html: is_ccp}}/></td>
                                            </tr> 
                                            <tr>
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(C) ${x?.chemical_hazard}`}}/></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: is_ch}}/></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.ch_justification}}/></td>    
                                            </tr> 
                                            <tr>
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: `(P) ${x?.physical_hazard}`}}/></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: is_ph}}/></td>    
                                                <td><div style={classes.tableText} dangerouslySetInnerHTML={{__html: x?.ph_justification}}/></td>    
                                            </tr>
                                        </>
                                    )}
                                ) }
                            </tbody>
                        </table>
                    </div>
                </>
            )
    }
}